import { CHAT_WINDOW_CONFIG, CHAT_WINDOW_WIDTH, MINIMIZE_WIDTH } from '../constant/common'

export function getChatWindowPosition(
  index: number,
  allChats: any[],
  minimize: Record<string, boolean>,
  // Distance from the viewport's right edge to the Messaging panel's left edge
  // (its CSS `right` offset + its width), measured from the rendered panel.
  panelSpan: number
): React.CSSProperties {
  const chat = allChats[index]
  const isMinimized = minimize[chat]
  const GAP = 10
  // Space between the panel and the first chat window. The old `width + 25`
  // assumed a 10px right offset, which left only 3px once the responsive CSS
  // moves the panel to `right: 22px` (<= 1024px).
  const PANEL_GAP = 15
  const mainWindowWidth = panelSpan + PANEL_GAP;

  // Calculate position based on the index - each chat maintains its position
  // This creates LinkedIn-like behavior where chats don't jump around
  let right = mainWindowWidth;

  // Add width of all previous chats (considering their current state)
  for (let i = 0; i < index; i++) {
    const prevChat = allChats[i];
    const isPrevMinimized = minimize[prevChat];
    const prevWidth = isPrevMinimized ? MINIMIZE_WIDTH : CHAT_WINDOW_WIDTH;
    right += prevWidth + GAP;
  }

  // Determine current chat's width based on minimize state
  const width = isMinimized ? MINIMIZE_WIDTH : CHAT_WINDOW_WIDTH;

  return {
    position: 'fixed',
    bottom: '0px',
    right: `${right}px`,
    width: `${width}px`,
    zIndex: 1000 - index,
    height: isMinimized ? 'auto' : '450px'
    // Transitions are now handled in CSS for smoother, more consistent animations
  }
}

export const getContainerProp = (el?: HTMLElement | null) =>
  el ? { container: el } : {};

export const getMaxChatWindows = (screenWidth?: number) => {
  const width = typeof window !== 'undefined' ? screenWidth ?? window.innerWidth : screenWidth ?? 0

  for (const config of CHAT_WINDOW_CONFIG) {
    if (width >= config.minWidth) {
      return config.maxWindows
    }
  }

  return 1;
}

export const formatLastSeen = (lastSeenDate: string | null): string => {
  if (!lastSeenDate) return 'Offline'

  const date = new Date(lastSeenDate)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Last seen just now'
  if (diffMins < 60) return `Last seen ${diffMins}m ago`
  if (diffHours < 24) return `Last seen ${diffHours}h ago`
  if (diffDays < 7) return `Last seen ${diffDays}d ago`

  return `Last seen ${date.toLocaleDateString()}`
}

export const getEventPath = (event?: Event): EventTarget[] => {
  // ✅ If no event, return empty path
  if (!event) return []

  // ✅ Standard Shadow DOM–safe path
  if (typeof (event as any).composedPath === 'function') {
    return (event as any).composedPath()
  }

  // ✅ Fallback (older browsers / polyfills)
  const path: EventTarget[] = []
  let target = event.target as any

  while (target) {
    path.push(target)
    target = target.parentNode || target.host
  }

  path.push(window)
  return path
}


export const getShadowRoot = () => {
  const host = document.querySelector('dubai-brokers-chat')
  return host?.shadowRoot
}